export default function SectionHeading({ eyebrow, title, text, align = 'left', tone = 'light', className = '' }) {
  const centered = align === 'center';
  const dark = tone === 'dark';
  return (
    <div className={`${centered ? 'mx-auto text-center' : ''} max-w-2xl ${className}`}>
      {eyebrow && <p className={`eyebrow ${centered ? 'justify-center' : ''} ${dark ? '!text-accent-300' : ''}`}>{eyebrow}</p>}
      <h2 className={`mt-3 text-balance text-3xl leading-[1.05] sm:text-5xl ${dark ? 'text-white' : 'text-ink-950'}`}>{title}</h2>
      {text && <p className={`mt-4 text-pretty text-base leading-relaxed ${dark ? 'text-ink-300' : 'text-ink-500'}`}>{text}</p>}
    </div>
  );
}
